(function () {
  const stickyCta = document.querySelector('.global-cta--sticky');
  if (!stickyCta) return;

  const SCROLL_THRESHOLD = 720;
  let ticking = false;

  function updateVisibility() {
    const show = window.scrollY > SCROLL_THRESHOLD;
    stickyCta.classList.toggle('is-visible', show);
    stickyCta.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateVisibility();
        ticking = false;
      });
    },
    { passive: true }
  );

  updateVisibility();
})();
